// Approximate coordinates for every supported city in canada_cities.js,
// kept as a separate compact table so the picker keeps its plain string
// lists. Entries are [city, provinceCode, lat, lng]. Accuracy of a town
// center within a few kilometres is plenty: the only consumer is nearest
// city snapping, where the runner up is always tens of kilometres away.
// City names MUST match canada_cities.js exactly (duplicates like Windsor
// ON/NS or Stratford ON/PE are disambiguated by the province code).

export const CITY_COORDS = [
  // Ontario
  ["Toronto", "ON", 43.6532, -79.3832],
  ["Ottawa", "ON", 45.4215, -75.6972],
  ["Mississauga", "ON", 43.589, -79.6441],
  ["Brampton", "ON", 43.7315, -79.7624],
  ["Hamilton", "ON", 43.2557, -79.8711],
  ["London", "ON", 42.9849, -81.2453],
  ["Markham", "ON", 43.8561, -79.337],
  ["Vaughan", "ON", 43.8372, -79.5083],
  ["Kitchener", "ON", 43.4516, -80.4925],
  ["Windsor", "ON", 42.3149, -83.0364],
  ["Richmond Hill", "ON", 43.8828, -79.4403],
  ["Oakville", "ON", 43.4675, -79.6877],
  ["Burlington", "ON", 43.3255, -79.799],
  ["Oshawa", "ON", 43.8971, -78.8658],
  ["Barrie", "ON", 44.3894, -79.6903],
  ["St. Catharines", "ON", 43.1594, -79.2469],
  ["Guelph", "ON", 43.5448, -80.2482],
  ["Cambridge", "ON", 43.3616, -80.3144],
  ["Whitby", "ON", 43.8975, -78.9429],
  ["Kingston", "ON", 44.2312, -76.486],
  ["Ajax", "ON", 43.8509, -79.0204],
  ["Milton", "ON", 43.5183, -79.8774],
  ["Thunder Bay", "ON", 48.3809, -89.2477],
  ["Waterloo", "ON", 43.4643, -80.5204],
  ["Greater Sudbury", "ON", 46.4917, -80.993],
  ["Clarington", "ON", 43.9351, -78.6087],
  ["Brantford", "ON", 43.1394, -80.2644],
  ["Pickering", "ON", 43.8384, -79.0868],
  ["Niagara Falls", "ON", 43.0896, -79.0849],
  ["Newmarket", "ON", 44.0592, -79.4613],
  ["Peterborough", "ON", 44.3091, -78.3197],
  ["Kawartha Lakes", "ON", 44.36, -78.74],
  ["Caledon", "ON", 43.8668, -79.8687],
  ["Sarnia", "ON", 42.9745, -82.4066],
  ["Halton Hills", "ON", 43.6465, -79.921],
  ["Sault Ste. Marie", "ON", 46.5219, -84.3461],
  ["Welland", "ON", 42.9922, -79.2482],
  ["Belleville", "ON", 44.1628, -77.3832],
  ["Aurora", "ON", 44.0065, -79.4504],
  ["North Bay", "ON", 46.3091, -79.4608],
  ["Cornwall", "ON", 45.0212, -74.73],
  ["Chatham-Kent", "ON", 42.4048, -82.191],
  ["Georgina", "ON", 44.2986, -79.4357],
  ["St. Thomas", "ON", 42.7784, -81.175],
  ["Woodstock", "ON", 43.1306, -80.7467],
  ["Innisfil", "ON", 44.3001, -79.603],
  ["Quinte West", "ON", 44.1002, -77.575],
  ["Bradford", "ON", 44.1147, -79.561],
  ["New Tecumseth", "ON", 44.09, -79.8],
  ["Timmins", "ON", 48.4758, -81.3305],
  ["Orillia", "ON", 44.6082, -79.4197],
  ["Stouffville", "ON", 43.9706, -79.2441],
  ["East Gwillimbury", "ON", 44.1085, -79.4419],
  ["Orangeville", "ON", 43.9199, -80.0943],
  ["Stratford", "ON", 43.3701, -80.9821],
  ["Fort Erie", "ON", 42.9042, -78.9285],
  ["Leamington", "ON", 42.0533, -82.5998],
  ["LaSalle", "ON", 42.2167, -83.0666],
  ["Grimsby", "ON", 43.2, -79.5613],
  ["Clarence-Rockland", "ON", 45.5501, -75.2917],
  ["Lincoln", "ON", 43.13, -79.43],
  ["Tecumseh", "ON", 42.3149, -82.8893],
  ["Amherstburg", "ON", 42.1013, -83.109],
  ["Brockville", "ON", 44.5895, -75.6843],
  ["Owen Sound", "ON", 44.567, -80.9435],
  ["Collingwood", "ON", 44.5006, -80.2169],
  ["Cobourg", "ON", 43.9593, -78.1677],
  ["Wasaga Beach", "ON", 44.5206, -80.0161],
  ["Pembroke", "ON", 45.8266, -77.1108],
  ["Petawawa", "ON", 45.8942, -77.2869],
  ["Strathroy", "ON", 42.9558, -81.6225],
  ["Midland", "ON", 44.75, -79.8848],
  ["Port Colborne", "ON", 42.8863, -79.2515],
  ["Thorold", "ON", 43.1167, -79.2],
  ["Niagara-on-the-Lake", "ON", 43.2551, -79.0718],
  ["Port Hope", "ON", 43.9511, -78.2919],
  ["Essex", "ON", 42.1751, -82.8247],
  ["Huntsville", "ON", 45.3266, -79.2199],
  ["Tillsonburg", "ON", 42.8631, -80.7276],
  ["Ingersoll", "ON", 43.0392, -80.8836],
  ["Carleton Place", "ON", 45.1417, -76.1442],
  ["Uxbridge", "ON", 44.1092, -79.1207],
  ["Lindsay", "ON", 44.3545, -78.7374],
  ["Alliston", "ON", 44.1531, -79.8686],
  ["Fergus", "ON", 43.7075, -80.38],
  ["Kenora", "ON", 49.767, -94.4894],
  ["Simcoe", "ON", 42.8371, -80.3044],
  ["Smiths Falls", "ON", 44.9013, -76.0227],
  ["Bracebridge", "ON", 45.0384, -79.3075],
  ["Elliot Lake", "ON", 46.3831, -82.6531],
  ["Gravenhurst", "ON", 44.9188, -79.3735],
  ["Kincardine", "ON", 44.1745, -81.636],
  ["Port Elgin", "ON", 44.4334, -81.3931],
  ["Hawkesbury", "ON", 45.6074, -74.6067],
  ["Goderich", "ON", 43.742, -81.7137],
  ["Listowel", "ON", 43.7351, -80.9534],
  ["Hanover", "ON", 44.1512, -81.0286],
  ["Renfrew", "ON", 45.4718, -76.6829],
  ["Arnprior", "ON", 45.4363, -76.3556],
  ["Perth", "ON", 44.8993, -76.2478],
  ["Napanee", "ON", 44.2489, -76.9497],
  ["Kemptville", "ON", 45.0163, -75.6437],
  ["Almonte", "ON", 45.2249, -76.1946],
  ["St. Marys", "ON", 43.2585, -81.1404],
  ["Kirkland Lake", "ON", 48.1447, -80.0378],
  ["Kapuskasing", "ON", 49.4169, -82.4331],
  ["Parry Sound", "ON", 45.3477, -80.0353],
  ["Dryden", "ON", 49.7797, -92.837],
  ["Fort Frances", "ON", 48.6109, -93.4008],
  ["Gananoque", "ON", 44.3297, -76.1618],
  ["Espanola", "ON", 46.26, -81.767],
  ["Walkerton", "ON", 44.129, -81.1481],
  ["Prescott", "ON", 44.7128, -75.5165],
  ["Deep River", "ON", 46.1005, -77.4894],
  // Quebec
  ["Montreal", "QC", 45.5019, -73.5674],
  ["Quebec City", "QC", 46.8139, -71.208],
  ["Laval", "QC", 45.6066, -73.7124],
  ["Gatineau", "QC", 45.4765, -75.7013],
  ["Longueuil", "QC", 45.5312, -73.5181],
  ["Sherbrooke", "QC", 45.4042, -71.8929],
  ["Lévis", "QC", 46.7382, -71.2465],
  ["Saguenay", "QC", 48.428, -71.0684],
  ["Trois-Rivières", "QC", 46.3432, -72.543],
  ["Terrebonne", "QC", 45.7057, -73.647],
  ["Saint-Jean-sur-Richelieu", "QC", 45.3007, -73.262],
  ["Brossard", "QC", 45.4515, -73.4657],
  ["Repentigny", "QC", 45.742, -73.45],
  ["Drummondville", "QC", 45.8833, -72.4823],
  ["Saint-Jérôme", "QC", 45.7804, -74.0036],
  ["Granby", "QC", 45.4, -72.7333],
  ["Blainville", "QC", 45.67, -73.88],
  ["Saint-Hyacinthe", "QC", 45.6307, -72.957],
  ["Mirabel", "QC", 45.6497, -74.0824],
  ["Shawinigan", "QC", 46.5668, -72.7441],
  ["Dollard-des-Ormeaux", "QC", 45.4942, -73.8242],
  ["Rimouski", "QC", 48.4488, -68.5236],
  ["Châteauguay", "QC", 45.38, -73.7496],
  ["Victoriaville", "QC", 46.0578, -71.964],
  ["Saint-Eustache", "QC", 45.5651, -73.9054],
  ["Mascouche", "QC", 45.7492, -73.6],
  ["Salaberry-de-Valleyfield", "QC", 45.257, -74.1289],
  ["Rouyn-Noranda", "QC", 48.236, -79.023],
  ["Boucherville", "QC", 45.5911, -73.4361],
  ["Sorel-Tracy", "QC", 46.0429, -73.113],
  ["Côte Saint-Luc", "QC", 45.4687, -73.6673],
  ["Vaudreuil-Dorion", "QC", 45.4, -74.0333],
  ["Val-d'Or", "QC", 48.0977, -77.7826],
  ["Pointe-Claire", "QC", 45.4489, -73.8166],
  ["Alma", "QC", 48.55, -71.65],
  ["Sainte-Julie", "QC", 45.5854, -73.332],
  ["Saint-Constant", "QC", 45.37, -73.566],
  ["Boisbriand", "QC", 45.6139, -73.8386],
  ["Sainte-Thérèse", "QC", 45.6389, -73.842],
  ["Magog", "QC", 45.2678, -72.1477],
  ["La Prairie", "QC", 45.42, -73.499],
  ["Thetford Mines", "QC", 46.094, -71.302],
  ["Sept-Îles", "QC", 50.2001, -66.3821],
  ["Saint-Bruno-de-Montarville", "QC", 45.534, -73.349],
  ["Chambly", "QC", 45.4479, -73.2896],
  ["Baie-Comeau", "QC", 49.2167, -68.15],
  ["Saint-Lambert", "QC", 45.495, -73.508],
  ["Beloeil", "QC", 45.5678, -73.205],
  ["Joliette", "QC", 46.023, -73.439],
  ["Saint-Lazare", "QC", 45.4, -74.1333],
  ["Candiac", "QC", 45.386, -73.519],
  ["L'Assomption", "QC", 45.8232, -73.429],
  ["Varennes", "QC", 45.684, -73.433],
  ["Kirkland", "QC", 45.45, -73.863],
  ["Beaconsfield", "QC", 45.427, -73.863],
  ["Mont-Royal", "QC", 45.516, -73.642],
  ["Westmount", "QC", 45.4833, -73.597],
  ["Dorval", "QC", 45.447, -73.753],
  ["Deux-Montagnes", "QC", 45.535, -73.893],
  ["Sainte-Catherine", "QC", 45.4, -73.58],
  ["Saint-Augustin-de-Desmaures", "QC", 46.7411, -71.452],
  ["L'Ancienne-Lorette", "QC", 46.8, -71.35],
  ["Mont-Saint-Hilaire", "QC", 45.562, -73.192],
  ["Rivière-du-Loup", "QC", 47.836, -69.534],
  ["Cowansville", "QC", 45.2, -72.75],
  ["Matane", "QC", 48.846, -67.526],
  ["Amos", "QC", 48.566, -78.116],
  ["Lachute", "QC", 45.65, -74.333],
  ["Mont-Laurier", "QC", 46.55, -75.5],
  ["Dolbeau-Mistassini", "QC", 48.878, -72.234],
  ["Gaspé", "QC", 48.833, -64.487],
  ["Montmagny", "QC", 46.98, -70.554],
  ["Sainte-Agathe-des-Monts", "QC", 46.05, -74.28],
  ["Mont-Tremblant", "QC", 46.118, -74.596],
  ["Bromont", "QC", 45.317, -72.649],
  ["Saint-Sauveur", "QC", 45.887, -74.17],
  ["La Tuque", "QC", 47.437, -72.781],
  ["Roberval", "QC", 48.521, -72.226],
  ["Baie-Saint-Paul", "QC", 47.441, -70.499],
  // British Columbia
  ["Vancouver", "BC", 49.2827, -123.1207],
  ["Surrey", "BC", 49.1913, -122.849],
  ["Burnaby", "BC", 49.2488, -122.9805],
  ["Richmond", "BC", 49.1666, -123.1336],
  ["Abbotsford", "BC", 49.0504, -122.3045],
  ["Coquitlam", "BC", 49.2838, -122.7932],
  ["Kelowna", "BC", 49.888, -119.496],
  ["Saanich", "BC", 48.484, -123.381],
  ["Delta", "BC", 49.0847, -123.0587],
  ["Langley", "BC", 49.1044, -122.6603],
  ["Kamloops", "BC", 50.6745, -120.3273],
  ["Nanaimo", "BC", 49.1659, -123.9401],
  ["Victoria", "BC", 48.4284, -123.3656],
  ["Chilliwack", "BC", 49.1579, -121.9515],
  ["Maple Ridge", "BC", 49.2193, -122.5984],
  ["Prince George", "BC", 53.9171, -122.7497],
  ["New Westminster", "BC", 49.2057, -122.911],
  ["Port Coquitlam", "BC", 49.2626, -122.7811],
  ["North Vancouver", "BC", 49.32, -123.0724],
  ["Langford", "BC", 48.4474, -123.5046],
  ["Vernon", "BC", 50.2671, -119.272],
  ["Mission", "BC", 49.1329, -122.3095],
  ["Penticton", "BC", 49.4991, -119.5937],
  ["Campbell River", "BC", 50.0244, -125.2475],
  ["West Kelowna", "BC", 49.8625, -119.5833],
  ["Port Moody", "BC", 49.2831, -122.8317],
  ["Courtenay", "BC", 49.6877, -124.9994],
  ["West Vancouver", "BC", 49.3286, -123.1602],
  ["Salmon Arm", "BC", 50.7001, -119.2838],
  ["Fort St. John", "BC", 56.2524, -120.8464],
  ["Cranbrook", "BC", 49.5122, -115.7694],
  ["White Rock", "BC", 49.0253, -122.8029],
  ["Squamish", "BC", 49.7016, -123.1558],
  ["Pitt Meadows", "BC", 49.2211, -122.6894],
  ["Port Alberni", "BC", 49.2339, -124.8055],
  ["Colwood", "BC", 48.4236, -123.4958],
  ["Esquimalt", "BC", 48.4306, -123.4147],
  ["Oak Bay", "BC", 48.4264, -123.3228],
  ["Central Saanich", "BC", 48.58, -123.42],
  ["Duncan", "BC", 48.7787, -123.7079],
  ["Comox", "BC", 49.6735, -124.9283],
  ["Prince Rupert", "BC", 54.315, -130.3208],
  ["Terrace", "BC", 54.5182, -128.6032],
  ["Powell River", "BC", 49.8353, -124.5247],
  ["Whistler", "BC", 50.1163, -122.9574],
  ["Sidney", "BC", 48.6506, -123.3986],
  ["Parksville", "BC", 49.315, -124.312],
  ["Dawson Creek", "BC", 55.7596, -120.2377],
  ["Quesnel", "BC", 52.9784, -122.4927],
  ["Williams Lake", "BC", 52.1417, -122.1417],
  ["Sooke", "BC", 48.3747, -123.7276],
  ["Nelson", "BC", 49.4928, -117.2948],
  ["Trail", "BC", 49.0966, -117.7117],
  ["Castlegar", "BC", 49.3237, -117.6593],
  ["Kitimat", "BC", 54.0524, -128.6534],
  ["Summerland", "BC", 49.6006, -119.6778],
  ["Sechelt", "BC", 49.4742, -123.7542],
  ["Ladysmith", "BC", 48.9975, -123.8203],
  ["Qualicum Beach", "BC", 49.35, -124.444],
  ["Merritt", "BC", 50.1113, -120.7862],
  ["Kimberley", "BC", 49.6697, -115.9775],
  ["Revelstoke", "BC", 50.9981, -118.1957],
  ["Osoyoos", "BC", 49.0325, -119.4682],
  ["Smithers", "BC", 54.7824, -127.1686],
  ["Fernie", "BC", 49.504, -115.0631],
  ["Hope", "BC", 49.383, -121.4419],
  ["Oliver", "BC", 49.183, -119.5504],
  ["Gibsons", "BC", 49.3959, -123.5057],
  ["Golden", "BC", 51.2961, -116.9631],
  ["Tofino", "BC", 49.153, -125.9066],
  ["Ucluelet", "BC", 48.9424, -125.5464],
  // Alberta
  ["Calgary", "AB", 51.0447, -114.0719],
  ["Edmonton", "AB", 53.5461, -113.4938],
  ["Red Deer", "AB", 52.2681, -113.8112],
  ["Lethbridge", "AB", 49.6942, -112.8328],
  ["St. Albert", "AB", 53.6305, -113.6256],
  ["Sherwood Park", "AB", 53.5413, -113.2958],
  ["Airdrie", "AB", 51.2917, -114.0144],
  ["Medicine Hat", "AB", 50.0405, -110.6764],
  ["Grande Prairie", "AB", 55.1707, -118.7947],
  ["Fort McMurray", "AB", 56.7267, -111.379],
  ["Spruce Grove", "AB", 53.545, -113.9008],
  ["Leduc", "AB", 53.2594, -113.5492],
  ["Cochrane", "AB", 51.189, -114.467],
  ["Okotoks", "AB", 50.7256, -113.9749],
  ["Fort Saskatchewan", "AB", 53.7128, -113.2133],
  ["Chestermere", "AB", 51.0382, -113.8225],
  ["Beaumont", "AB", 53.3521, -113.4151],
  ["Camrose", "AB", 53.0166, -112.828],
  ["Stony Plain", "AB", 53.5265, -114.0077],
  ["Sylvan Lake", "AB", 52.3111, -114.0964],
  ["Canmore", "AB", 51.0899, -115.3593],
  ["Brooks", "AB", 50.5642, -111.8989],
  ["Strathmore", "AB", 51.0378, -113.4002],
  ["High River", "AB", 50.581, -113.874],
  ["Lacombe", "AB", 52.4682, -113.737],
  ["Wetaskiwin", "AB", 52.9694, -113.3769],
  ["Lloydminster", "AB", 53.2783, -110.0055],
  ["Cold Lake", "AB", 54.4642, -110.1825],
  ["Blackfalds", "AB", 52.383, -113.786],
  ["Morinville", "AB", 53.802, -113.6497],
  ["Taber", "AB", 49.786, -112.15],
  ["Coaldale", "AB", 49.73, -112.618],
  ["Banff", "AB", 51.1784, -115.5708],
  ["Whitecourt", "AB", 54.1417, -115.68],
  ["Hinton", "AB", 53.4114, -117.5639],
  ["Olds", "AB", 51.7928, -114.1067],
  ["Edson", "AB", 53.5817, -116.434],
  ["Innisfail", "AB", 52.0295, -113.95],
  ["Drumheller", "AB", 51.4632, -112.7089],
  ["Ponoka", "AB", 52.677, -113.581],
  ["Drayton Valley", "AB", 53.222, -114.977],
  ["Slave Lake", "AB", 55.2853, -114.77],
  ["Rocky Mountain House", "AB", 52.375, -114.921],
  ["Wainwright", "AB", 52.839, -110.857],
  ["Stettler", "AB", 52.3235, -112.711],
  ["St. Paul", "AB", 53.993, -111.297],
  ["Vegreville", "AB", 53.493, -112.052],
  ["Bonnyville", "AB", 54.267, -110.735],
  ["Devon", "AB", 53.363, -113.732],
  ["Peace River", "AB", 56.234, -117.29],
  ["Didsbury", "AB", 51.666, -114.138],
  ["Jasper", "AB", 52.8737, -118.0814],
  // Manitoba
  ["Winnipeg", "MB", 49.8951, -97.1384],
  ["Brandon", "MB", 49.8485, -99.9501],
  ["Steinbach", "MB", 49.5258, -96.6839],
  ["Winkler", "MB", 49.1817, -97.9397],
  ["Thompson", "MB", 55.7435, -97.8558],
  ["Portage la Prairie", "MB", 49.9728, -98.2926],
  ["Selkirk", "MB", 50.1436, -96.8839],
  ["Morden", "MB", 49.1919, -98.1013],
  ["Dauphin", "MB", 51.1494, -100.0502],
  ["The Pas", "MB", 53.8251, -101.2541],
  ["Niverville", "MB", 49.6053, -97.0428],
  ["Flin Flon", "MB", 54.7682, -101.865],
  ["Stonewall", "MB", 50.1344, -97.3266],
  ["Altona", "MB", 49.1047, -97.5602],
  ["Oakbank", "MB", 49.9331, -96.8464],
  ["Neepawa", "MB", 50.2286, -99.4661],
  ["Beausejour", "MB", 50.0622, -96.5161],
  ["Carman", "MB", 49.4992, -98.0011],
  ["Virden", "MB", 49.8508, -100.932],
  ["Gimli", "MB", 50.6339, -96.9898],
  ["Swan River", "MB", 52.1058, -101.2676],
  ["Headingley", "MB", 49.87, -97.403],
  ["Morris", "MB", 49.355, -97.365],
  ["Killarney", "MB", 49.183, -99.664],
  ["Lac du Bonnet", "MB", 50.2536, -96.0611],
  ["Roblin", "MB", 51.229, -101.356],
  // Saskatchewan
  ["Saskatoon", "SK", 52.1332, -106.67],
  ["Regina", "SK", 50.4452, -104.6189],
  ["Prince Albert", "SK", 53.2033, -105.7531],
  ["Moose Jaw", "SK", 50.3934, -105.5519],
  ["Swift Current", "SK", 50.2851, -107.7972],
  ["Yorkton", "SK", 51.2139, -102.4628],
  ["North Battleford", "SK", 52.7575, -108.2861],
  ["Warman", "SK", 52.3219, -106.5842],
  ["Estevan", "SK", 49.1391, -102.9861],
  ["Weyburn", "SK", 49.6611, -103.8525],
  ["Martensville", "SK", 52.2897, -106.6667],
  ["Melfort", "SK", 52.8561, -104.6106],
  ["Humboldt", "SK", 52.2019, -105.1231],
  ["Meadow Lake", "SK", 54.1242, -108.4358],
  ["Melville", "SK", 50.9306, -102.8078],
  ["Kindersley", "SK", 51.4672, -109.1581],
  ["Battleford", "SK", 52.7395, -108.311],
  ["Nipawin", "SK", 53.366, -104.009],
  ["Tisdale", "SK", 52.85, -104.05],
  ["La Ronge", "SK", 55.1, -105.3],
  ["Moosomin", "SK", 50.142, -101.672],
  ["Assiniboia", "SK", 49.627, -105.986],
  ["Unity", "SK", 52.44, -109.165],
  ["Rosetown", "SK", 51.554, -107.993],
  ["Outlook", "SK", 51.5, -107.05],
  ["Esterhazy", "SK", 50.658, -102.079],
  // Nova Scotia
  ["Halifax", "NS", 44.6488, -63.5752],
  ["Dartmouth", "NS", 44.6653, -63.5677],
  ["Sydney", "NS", 46.1368, -60.1942],
  ["Truro", "NS", 45.3646, -63.2799],
  ["New Glasgow", "NS", 45.5926, -62.6455],
  ["Glace Bay", "NS", 46.1969, -59.957],
  ["Kentville", "NS", 45.0771, -64.496],
  ["Amherst", "NS", 45.8167, -64.2167],
  ["Bridgewater", "NS", 44.3776, -64.5186],
  ["Yarmouth", "NS", 43.8375, -66.1174],
  ["Antigonish", "NS", 45.6215, -61.9986],
  ["Wolfville", "NS", 45.0918, -64.3644],
  ["Windsor", "NS", 44.99, -64.136],
  ["Stellarton", "NS", 45.559, -62.66],
  ["Port Hawkesbury", "NS", 45.616, -61.363],
  ["Pictou", "NS", 45.6786, -62.7113],
  ["Digby", "NS", 44.622, -65.758],
  ["Berwick", "NS", 45.045, -64.733],
  ["Middleton", "NS", 44.941, -65.07],
  ["Liverpool", "NS", 44.041, -64.716],
  ["Lunenburg", "NS", 44.3768, -64.3084],
  ["Shelburne", "NS", 43.763, -65.323],
  // New Brunswick
  ["Moncton", "NB", 46.0878, -64.7782],
  ["Saint John", "NB", 45.2733, -66.0633],
  ["Fredericton", "NB", 45.9636, -66.6431],
  ["Dieppe", "NB", 46.0989, -64.6873],
  ["Riverview", "NB", 46.0617, -64.8052],
  ["Quispamsis", "NB", 45.4322, -65.9462],
  ["Miramichi", "NB", 47.0287, -65.5017],
  ["Edmundston", "NB", 47.3737, -68.3251],
  ["Rothesay", "NB", 45.383, -65.996],
  ["Bathurst", "NB", 47.618, -65.651],
  ["Oromocto", "NB", 45.848, -66.479],
  ["Campbellton", "NB", 48.0075, -66.6731],
  ["Grand Falls", "NB", 47.047, -67.739],
  ["Shediac", "NB", 46.22, -64.541],
  ["Tracadie", "NB", 47.514, -64.911],
  ["Sackville", "NB", 45.897, -64.368],
  ["Woodstock", "NB", 46.1527, -67.6016],
  ["Sussex", "NB", 45.722, -65.506],
  ["Caraquet", "NB", 47.794, -64.938],
  ["Grand Bay-Westfield", "NB", 45.361, -66.236],
  ["St. Stephen", "NB", 45.194, -67.275],
  ["Dalhousie", "NB", 48.066, -66.373],
  // Newfoundland and Labrador
  ["St. John's", "NL", 47.5615, -52.7126],
  ["Conception Bay South", "NL", 47.517, -52.996],
  ["Mount Pearl", "NL", 47.5189, -52.8058],
  ["Paradise", "NL", 47.536, -52.864],
  ["Corner Brook", "NL", 48.95, -57.952],
  ["Grand Falls-Windsor", "NL", 48.937, -55.664],
  ["Gander", "NL", 48.9564, -54.6089],
  ["Portugal Cove-St. Philip's", "NL", 47.626, -52.85],
  ["Torbay", "NL", 47.666, -52.733],
  ["Happy Valley-Goose Bay", "NL", 53.302, -60.326],
  ["Labrador City", "NL", 52.946, -66.912],
  ["Stephenville", "NL", 48.55, -58.572],
  ["Clarenville", "NL", 48.156, -53.967],
  ["Bay Roberts", "NL", 47.599, -53.265],
  ["Marystown", "NL", 47.167, -55.145],
  ["Deer Lake", "NL", 49.174, -57.431],
  ["Carbonear", "NL", 47.736, -53.214],
  ["Channel-Port aux Basques", "NL", 47.572, -59.137],
  // Prince Edward Island
  ["Charlottetown", "PE", 46.2382, -63.1311],
  ["Summerside", "PE", 46.395, -63.7891],
  ["Stratford", "PE", 46.217, -63.089],
  ["Cornwall", "PE", 46.228, -63.219],
  ["Montague", "PE", 46.165, -62.648],
  ["Kensington", "PE", 46.436, -63.642],
  ["Souris", "PE", 46.35, -62.248],
  ["Alberton", "PE", 46.814, -64.065],
  ["Tignish", "PE", 46.95, -64.035],
  // Yukon
  ["Whitehorse", "YT", 60.7212, -135.0568],
  ["Dawson City", "YT", 64.0601, -139.433],
  ["Watson Lake", "YT", 60.063, -128.709],
  ["Haines Junction", "YT", 60.752, -137.511],
  ["Carmacks", "YT", 62.089, -136.289],
  ["Faro", "YT", 62.232, -133.356],
  ["Mayo", "YT", 63.594, -135.896],
  ["Teslin", "YT", 60.173, -132.743],
  // Northwest Territories
  ["Yellowknife", "NT", 62.454, -114.3718],
  ["Hay River", "NT", 60.8156, -115.7999],
  ["Inuvik", "NT", 68.3607, -133.723],
  ["Fort Smith", "NT", 60.0055, -111.8849],
  ["Behchoko", "NT", 62.8025, -116.0464],
  ["Fort Simpson", "NT", 61.863, -121.354],
  ["Norman Wells", "NT", 65.282, -126.832],
  ["Fort Providence", "NT", 61.352, -117.659],
  ["Tuktoyaktuk", "NT", 69.445, -133.034],
  // Nunavut
  ["Iqaluit", "NU", 63.7467, -68.517],
  ["Rankin Inlet", "NU", 62.8084, -92.0853],
  ["Arviat", "NU", 61.108, -94.0586],
  ["Baker Lake", "NU", 64.319, -96.021],
  ["Cambridge Bay", "NU", 69.117, -105.053],
  ["Igloolik", "NU", 69.376, -81.799],
  ["Pond Inlet", "NU", 72.699, -77.959],
  ["Pangnirtung", "NU", 66.145, -65.713],
  ["Kugluktuk", "NU", 67.827, -115.096],
  ["Kinngait", "NU", 64.231, -76.54],
  ["Gjoa Haven", "NU", 68.635, -95.849],
];

const EARTH_RADIUS_KM = 6371;
const toRad = (deg) => (deg * Math.PI) / 180;

// Great circle distance in km. Precise enough at city scale that the exact
// Earth model does not matter for picking a nearest neighbour.
export function haversineKm(lat1, lng1, lat2, lng2) {
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.sqrt(a));
}

// Exact coordinates for a supported city, or null when we do not carry them.
export function cityCoords(city, province) {
  const row = CITY_COORDS.find(
    (r) => r[0] === city && (!province || r[1] === province)
  );
  return row ? { lat: row[2], lng: row[3] } : null;
}

// Snap real coordinates (browser geolocation or IP lookup) to the nearest
// supported market. Returns {city, province} or null for unusable input, so
// callers can fall through to the next rung of the detection ladder.
export function nearestCity(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  let best = null;
  let bestKm = Infinity;
  for (const [city, province, cLat, cLng] of CITY_COORDS) {
    const km = haversineKm(lat, lng, cLat, cLng);
    if (km < bestKm) {
      bestKm = km;
      best = { city, province };
    }
  }
  return best;
}
